import { render, staticRenderFns } from "./UserDetail.vue?vue&type=template&id=7aa465f1&scoped=true"
import script from "./UserDetail.vue?vue&type=script&lang=ts"
export * from "./UserDetail.vue?vue&type=script&lang=ts"
import style0 from "./UserDetail.vue?vue&type=style&index=0&id=7aa465f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa465f1",
  null
  
)

export default component.exports